<div class="container text-center py-5">
  <div class="card shadow-lg p-4 mx-auto" style="max-width: 500px;">
    <div class="checkmark-container mb-4">
      <div class="checkmark"></div>
    </div>

    <h2 class="text-success mb-2">¡Pago Exitoso!</h2>
    <p class="text-muted">Tu transacción se completó correctamente.</p>

    <div class="text-left mt-4 mb-3">
      <p><strong>Referencia de Venta:</strong> {{ referencia }}</p>
      <p><strong>Tipo de Pago:</strong> {{ type }}</p>
      <p><strong>ID de Transacción:</strong> {{ transactionId }}</p>
      <p><strong>Estado:</strong> {{ status }}</p>
      <p><strong>Fecha:</strong> {{ fecha }}</p>

      <ng-container *ngIf="detalleVenta">
        <hr />
        <p><strong>Cliente:</strong> {{ detalleVenta?.cliente }}</p>
        <p><strong>Monto:</strong> ${{ detalleVenta?.monto }}</p>
      </ng-container>
    </div>

    <a [routerLink]="['/']" routerLinkActive="router-link-active" class="btn btn-success btn-block">Volver al inicio</a>
  </div>
</div>